export const COLUMN_WITH_DATE = 'with_event_responsibility_in_time_period'
export const COLUMN_WITHOUT_DATE = 'volunteerships_responsibility'
export const RESPONSIBILITY_INDEX = 0
export const START_DATE_INDEX = 1
export const END_DATE_INDEX = 2
